import { render, staticRenderFns } from "./ProjectsEditPage.vue?vue&type=template&id=4527cfad&"
import script from "./ProjectsEditPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4527cfad')) {
      api.createRecord('4527cfad', component.options)
    } else {
      api.reload('4527cfad', component.options)
    }
    module.hot.accept("./ProjectsEditPage.vue?vue&type=template&id=4527cfad&", function () {
      api.rerender('4527cfad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsEditPage.vue"
export default component.exports